<template>

    <span>
        <span class="alarmeJeBereich" v-if="chartdata">
           <bar-chart
                   v-if="loaded"
                   :chartdata="chartdata"
                   v-on:set-chart="setChart"
                   :options="options"
           />
        </span>
        <div v-else-if="!chartdata && !loaded" class="text-center">
            <SpinnerImage />
        </div>
    </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true
    import BarChart from '@/components/charts/BarChart.vue'
    import SpinnerImage from '@/components/layout/SpinnerImage'

    export default {
      name: 'BarChartAlarmeJeBereicheTraplinked',
      components: {
        BarChart,
        SpinnerImage
      },
      props: ['traplinkedbericht', 'customer', 'keyUser', 'subUser', 'filter', 'auftrag'],
      data () {
        return {
          loaded: false,
          /** Daten für den Bar Chart */
          chartdata: null,
          options: {
            onClick: this.chartClickEvent,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              title: {
                display: true,
                text: this.$t('message.charts_alarme_je_bereich')
              },
              tooltip: {
                callbacks: {
                  label: function (ctx) {
                    let label = ctx.dataset.label || ''
                    if (label) {
                      label += ': ' + ctx.parsed.y
                    }
                    return label + ' %'
                  }
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                stacked: true,
                ticks: {
                  callback: function (value) { if (Number.isInteger(value)) { return value + '%'; } },
                  stepSize: 10
                }
              },
              x: {
                stacked: true
              }
            }
          },
          /** Chart.js Chart */
          chart: null,
          /** Filter der Charts */
          filterung: {
            /** Filter nach einer Objektkategorie */
            filterObjektkategorie: null,
            /** Filter nach einer Area */
            filterArea: null
          }
        }
      },
      watch: {
        traplinkedbericht: function () {
            this.init()
        },
        customer: function () {
          this.init()
        },
        keyUser: function () {
          this.init()
        },
        subUser: function () {
          this.init()
        },
        filter: {
          handler: function (newObj) {
            console.log('Filter changed, reload chart for BarChartAlarmeJeBereich ' + newObj)
            this.filterung = newObj
            this.init()
          },
          deep: true
        }
      },
      created () {

        this.init()

      },
      methods: {

        /**
         * Klick auf den Chart, Filter setzen
         * @param event click Event
         */
        chartClickEvent: function (event) {

          console.log('chartClickEvent ' + event)
          const elements = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true)
          if (elements && elements.length > 0) {
            const idx = elements[0].index
            console.log('index = ' + idx)
            var label = this.chart.config.data.labels[idx]
            console.log('label = ' + label)
            if (label) {
              this.doFilterArea(label)
            }
          }

        },
        /**
         * nach einer Objektkategorie filtern
         * @param label Objekttyp Bezeichnung
         */
        doFilterArea: function (label) {

          if (label) {
            this.filterung.areaToFilter = label
            this.$emit('filter-area', label)
          }

        },
        /**
         * Chart des Parents zurückliefern um Klick Events zu behandeln
         */
        setChart: function (obj) {
          this.chart = obj
        },
        /**
         * prüft ob im übergebenen Ergebnis Daten > 0 vorhanden sind
         */
        isDataAvailable: function (dataset) {

          for (let i = 0; i < dataset.data.length; i++) {
            const data = dataset.data[i]
            if (data > 0) return true
          }
          return false

        },
        init: async function () {

          console.log('hole charts für Traplinkedbericht AlarmeJeBereich ...')
          // Chart nicht anzeigen wenn z. B. keine Einzelaufträge angezeigt werden sollen,
          // aber derzeit ein Einzelauftrag ausgewählt wurde,
          // das gleiche für Monitoringaufträge
          if (this.filter && this.filter.auftragsart && this.traplinkedbericht && this.auftrag && this.auftrag.herkunft) {

            if (
                (this.auftrag.herkunft == 'Servicevertrag'        && this.filter.auftragsart.monitoringbesuch == 'false') ||
                (this.auftrag.herkunft == 'Einzelauftrag'         && this.filter.auftragsart.einzelauftrag == 'false')    ||
                (this.filter.auftragsart.einzelauftrag == 'false' && this.filter.auftragsart.monitoringbesuch == 'false')
            ) {
              console.log('Chart BarChartAlarmeJeObjektkategorie nicht anzeigen da Serviceverträge gefiltert sind.')
              this.chartdata = null
              this.loaded    = true
              return
            }

          }

          this.loaded    = false
          this.chartdata = null
          if (this.customer) this.$store.commit('setChartAvailableBarChartAlarmeJeBereiche', true)
          if (this.traplinkedbericht || this.customer || this.keyUser || this.subUser) {

            // ein SubUser kann ein normaler SubUser oder ein KeyUser sein der von einem anderen KeyUser hinzugefügt wurde
            let subUserId = null
            if (this.keyUser) {
              subUserId = this.keyUser.id
            } else if (this.subUser) {
              subUserId = this.subUser.id
            }

            const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataOfBesuchsbericht'
            const params  = {
              traplinkedbericht_id:     this.traplinkedbericht ? this.traplinkedbericht.id : null,
              customer_id:              this.customer ? this.customer.id : null,
              key_user_id:              this.keyUser ? this.keyUser.keyUserId : null,
              sub_user_id:              subUserId,
              mandant:                  this.keyUser ? this.keyUser.biotechCountry.name : null,
              type:                     'BAR_CHART_ALARME_JE_BEREICH_TRAPLINKED',
              filterObjektkategorie:    this.filterung ? this.filterung.filterObjektkategorie : null,
              filterArea:               this.filterung ? this.filterung.filterArea : null,
              areasAllowed:             this.$store.getters.benutzerrechte ? this.$store.getters.benutzerrechte.showAreas : null,
              auftragsart:              this.filterung ? JSON.stringify(this.filterung.auftragsart) : null,
            }

            const that = this
            await axios({
              method: 'GET',
              params: params,
              url: url
            }).then(function (response) {

              console.log('Chart Data AlarmeJeBereich für Traplinked verfügbar ... ')
              if (response.data) {

                that.chartdata = response.data.chartdata
                if (that.chartdata) {

                  const datasets = that.chartdata.datasets
                  if (datasets) {

                    if (that.isDataAvailable(datasets[0]) || that.isDataAvailable(datasets[1]) || that.isDataAvailable(datasets[2])) {
                      console.log('alarme je bereich verfügbar.')
                      if (that.customer) that.$store.commit('setChartAvailableBarChartAlarmeJeBereicheTraplinked', true)
                    } else {
                      that.chartdata = null
                      if (that.customer) that.$store.commit('setChartAvailableBarChartAlarmeJeBereicheTraplinked', false)
                    }

                  }

                } // end if that.chartdata
                if (response.data.dataStart) {
                  // setze Title des Charts
                  that.options.plugins.title.text = that.$t('message.charts_alarme_je_bereich_seit') + that.javaDateToDefaultDateFormat(response.data.dataStart)
                }

              }
              that.loaded = true

            }).catch(error => {
              console.log(error);
              that.loaded = true
            })
          }

        }

      }

    }

</script>
